<nz-sider class="menu-sidebar" nzCollapsible *ngIf="showMenu" nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">

    <div class="sidebar-logo">
        <a href="https://ng.ant.design/" target="_blank">
            <img src="../assets/img/logomarca_2.png" alt="logo">
            <h1>Consulta PBM</h1>
        </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-menu-item>
            <a routerLink="/">
                <i nz-icon nzType="home" nzTheme="outline"></i>
                <span>Página Inicial</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="medicamento">
                <i nz-icon nzType="medicine-box" nzTheme="outline"></i>
                <span>Medicamentos</span>
            </a>
        </li>


        <li nz-menu-item>
            <a routerLink="autorizador">
                <i nz-icon nzType="file-protect" nzTheme="outline"></i>
                <span>Autorizadoras</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="programa">
                <i nz-icon nzType="file-protect" nzTheme="outline"></i>
                <span>Programas</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="laboratorio">
                <i nz-icon nzType="experiment" nzTheme="outline"></i>
                <span>Laboratórios</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="lead">
                <i nz-icon nzType="team" nzTheme="outline"></i>
                <span>Leads</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="pesquisa">
                <i nz-icon nzType="search" nzTheme="outline"></i>
                <span>Pesquisas</span>
            </a>
        </li>
        <li nz-submenu nzTitle="Segurança" nzIcon="lock">
            <ul>
                <li nz-menu-item nzMatchRouter>
                    <i nz-icon nzType="usergroup-add"></i>
                    <a routerLink="/usuario">Usuários </a>
                </li>
            </ul>
            <ul>
                <li nz-menu-item nzMatchRouter>
                    <i nz-icon nzType="safety"></i>
                    <a routerLink="/tokens">Tokens</a>
                </li>
            </ul>
        </li>
        <li nz-menu-item>
            <a routerLink="configuracao">
                <i nz-icon nzType="setting" nzTheme="outline"></i>
                <span>Configurações</span>
            </a>
        </li>
        <li nz-menu-item>
            <a routerLink="mensagem">
                <i nz-icon nzType="message" nzTheme="outline"></i>
                <span>Banners</span>
            </a>
        </li>
        <li nz-menu-item>
            <a (click)="deslogar()">
                <i nz-icon nzType="logout" nzTheme="outline"></i>
                <span>Sair</span>
            </a>
        </li>

    </ul>
</nz-sider>
<nz-layout class="app-layout">

    <nz-layout>
        <nz-header *ngIf="showMenu">

            <div class="app-header">
                <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
                    <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
                </span>
                <div class="logo">
                    <a nz-button nzType="text" style="background-color: transparent; border:none;" nz-popover [nzPopoverTitle]="null" [nzPopoverContent]="contentTemplate" nzPopoverTrigger="click" (click)="abrirNotificacoes()">
                        <nz-badge [(nzDot)]="notificacoesPendente" style="margin-right: 12px; font-size:10px;">
                            <i nz-icon nzType="bell" style="font-size:20px; "></i>
                        </nz-badge>
                    </a>
                    <nz-avatar nzIcon="user" [nzShape]="'square'"></nz-avatar>
                    <span style="color:black; margin-left: 10px; margin-right: 10px;">{{infoUsuario.name}}</span>
                    <a nz-button nzType="text" style="background-color: transparent; border:none;" (click)="deslogar()">
                        <i nz-icon nzType="logout" style="font-size:20px;"></i>
                    </a>
                </div>
            </div>
        </nz-header>
        <nz-content>
            <div class="inner-content" *ngIf="showMenu else telaLogin">
                <router-outlet></router-outlet>
            </div>
            <ng-template #telaLogin>
                <router-outlet></router-outlet>
            </ng-template>
        </nz-content>
        <nz-footer>{{empresa_rodape}} ©{{ano}} - v{{versao_aplicacao}}</nz-footer>
    </nz-layout>
</nz-layout>


<ng-template #contentTemplate style="padding: 0px!important;">
    <div class="notif-panel">
        <div class="notif-header">
            <div class="notif-title">Notificações</div>
            <div class="notif-count" *ngIf="notificacoes.length > 0">{{ notificacoes.length }} no total</div>
        </div>
        <nz-list nzItemLayout="horizontal" [nzLoading]="loading" class="notif-list">
            <nz-list-item *ngFor="let item of notificacoes" class="notif-item" [ngClass]="{ 'is-unread': !item.lido }">
                <div class="notif-dot" [class.is-unread]="!item.lido"></div>
                <div class="notif-body">
                    <div class="notif-text" [class.is-read]="item.lido">{{ item.descricao }}</div>
                    <div class="notif-meta">
                        <span class="notif-status" [class.is-unread]="!item.lido">{{ item.lido ? 'Lida' : 'Nova' }}</span>
                        <span class="notif-time">{{ item.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                    </div>
                </div>
            </nz-list-item>
            <nz-list-empty *ngIf="notificacoes.length === 0"></nz-list-empty>
        </nz-list>
    </div>
</ng-template>
